import { AfterViewInit, Component, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    EventService,
    NotificationModel,
    NotificationService,
    WindowService,
} from '@evorait/pace-core';
import {
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'pace-longtext',
    templateUrl: './longtext.component.html',
    styleUrls: ['./longtext.component.scss'],
})
export class LongtextComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    private readonly window: Window;

    @Input()
    public notification: NotificationModel;
    public isCollapsed = true;

    public strings: {
        notificationLongtextTitle: string;
        preclarificationLongtextTitle: string;
        showMore: string;
        showLess: string;
    };

    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public faChevronRight = faChevronRight;
    public faChevronLeft = faChevronLeft;
    public faEnvelope = faEnvelope;

    public isPaceUs = false;
    public showExpander = true;
    private destroySubject = new Subject<void>();
    public constructor(
        private readonly translate: TranslateService,
        private readonly notificationService: NotificationService,
        private readonly eventService: EventService,
        private readonly windowService: WindowService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.window = this.windowService.nativeWindow;

        if (this.clientManager.isPaceUS()) {
            this.isCollapsed = false;
            this.showExpander = false;
        }
    }

    public ngOnInit(): void {
        this.strings = {
            notificationLongtextTitle: <string>(
                this.translate.instant('NOTIFICATION_DETAILS_LONG_TEXT_INFO_NOTIFICATION_TITLE')
            ),
            preclarificationLongtextTitle: <string>(
                this.translate.instant('NOTIFICATION_DETAILS_LONG_TEXT_INFO_PRE_CLARIFICATION_TITLE')
            ),
            showMore: <string>this.translate.instant('NOTIFICATION_DETAILS_LONG_TEXT_SHOW_MORE'),
            showLess: <string>this.translate.instant('NOTIFICATION_DETAILS_LONG_TEXT_SHOW_LESS'),
        };

        this.isPaceUs = this.clientManager.isPaceUS();
    }

    public ngAfterViewInit(): void {
        this.eventService.notificationsUpdated$
            .pipe(
                tap((isCancellationConfirmed) => {
                    if (isCancellationConfirmed || !this.notification) {
                        return;
                    }
                    // get the latest notification model with updated properties
                    const notification = this.notificationService.getNotificationByIdentifier(
                        this.notification.identifier,
                    );
                    if (!notification) {
                        throw new Error(
                            `LongtextComponent: Could not reload notification '${this.notification.identifier}'!`,
                        );
                    }
                    this.notification = notification;
                }),
                takeUntil(this.destroySubject),
            )
            .subscribe();
    }

    public ngOnChanges(changeObj: SimpleChanges): void {
        if (changeObj.model && changeObj.model.currentValue) {
            this.notification = <NotificationModel>changeObj.model.currentValue;
        }
    }

    public ngOnDestroy(): void {
        this.destroySubject.next();
    }

    public onEmailClick(): void {
        const emailAddresses = this.notification.partnerEmailAddresses;
        if (emailAddresses.length > 0) {
            const emailSeparator = this.clientManager.isWindows() ? '; ' : ', ';
            const emailAddressesString = emailAddresses.join(emailSeparator);
            // not using ces wrapper, as the send e-mail functionality should be working for windows
            this.window.location.href = `mailto:${emailAddressesString}`;
        }
    }
}
